function generateKey(pre) {
    return `${pre}-${new Date().getTime()}`;
}

function checkBrowser(){
    // Get the user-agent string
    let userAgentString = navigator.userAgent;
    let browserAgent;
    // Detect Chrome
    if(userAgentString.indexOf("Chrome") > -1){
        browserAgent = "chrome";
    }

    // Detect Internet Explorer
    if(userAgentString.indexOf("MSIE") > -1 ||
        userAgentString.indexOf("rv:") > -1){
        browserAgent = "ie";
    }

    // Detect Firefox
    if(userAgentString.indexOf("Firefox") > -1){
        browserAgent = "firefox";
    }

    // Detect Safari
    if(userAgentString.indexOf("Safari") > -1){
        browserAgent = "safari";
    }

    // Detect Opera
    if(userAgentString.indexOf("OP") > -1){
        browserAgent = "opera";
    }

    return browserAgent;
}

function parseDataObject(data) {
    var tempData = Object.assign({}, data);
    var parseData = {}
    Object.keys(tempData).forEach(function(key) {
        parseData[key.toLowerCase()] = tempData[key];
    });
    return parseData;
}

export {
    generateKey,
    checkBrowser,
    parseDataObject
}
